import React from "react";

import { Row, Col } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import Button from "shared/components/Button";
import Space from "shared/components/Space";
import { NAME_SPACES } from "shared/locals/constants";
import { useInfo } from "utils/hooks/info";

import "./style.scss";

const Component = ({ onYes, onNo }) => {
  const { t } = useTranslation(NAME_SPACES.AUTH);
  const { info } = useInfo();

  return (
    <div className="page-card">
      <div className={"center"}>
        <AiOutlineQuestionCircle size={50} />
        <Space h={24} />
        <h1>{t("LOGIN_FAILED_MESSAGE", { name: info.name })}</h1>
        <Space h={24} />
        <Row className="btnContainer">
          <Col>
            <Button text={t("YES")} onClick={onYes} />
          </Col>
          <Col>
            <Button text={t("NO")} onClick={onNo} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

Component.propTypes = {
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired,
};

export default Component;
